var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oferta-text"},[_vm._v("\n  Нажимая кнопку «Проверить» вы принимаете условия\n  "),_c('openPdf',[_vm._v("оферты")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }